import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { UserInfo } from '../constants/types';
import UsersService from '../services/users.service';
import { AuthContext } from './auth.context';
import authStore from './auth.store';

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [user, setUser] = useState<UserInfo | null>(authStore.user);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    authStore.subscribe(setUser);

    setLoading(true);
    new UsersService()
      .getUserData(false)
      .then(response => {
        if (response.data.redirect) {
          window.location.href = response.data.redirect;
        }

        authStore.setUser(response.data);
      })
      .catch(() => authStore.setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = (user: UserInfo) => {
    authStore.setUser(user);
  };

  const logout = () => {
    authStore.setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
};
